import {createContext} from "react";

// This context stores the file tree which has the source
// code for each of the files in the program.
const FileTreeContext = createContext();

export default FileTreeContext;
